export default "__VITE_ASSET__BaxAij8l__"